// extracted by mini-css-extract-plugin
export default {"container":"Error_container__Rm92u","spanStyle":"Error_spanStyle__NnP22","pic":"Error_pic__e3a8M","fadeIn":"Error_fadeIn__XxVzO"};